<div class="">
  <app-instructions [instructionType]="instructionType()"></app-instructions>
</div>
